export enum LinkType {
  CREATE,
  DETAIL,
  EDIT,
  DELETE,
  EXPORT,
  DUPLICATE,
  CUSTOM
}
